import _ from 'underscore';
import Backbone from "backbone";
import Chaplin from "chaplin";
import MoveToFolderPopupView from "views/common/MoveToFolderPopupView";
import RSVP from "rsvp";

const MoveToFolderPopupController = Chaplin.Controller.extend({

    initialize: function(options) {
        _.extend(this, Backbone.Events);
        this._parentController = options.parentController;
        this._folders = options.folders || [];
        this._currentFolderId = options.currentFolderId;
        this._onConfirm = options.onConfirm;
        this._onCancel = options.onCancel;
        this._ti18n = options.ti18n;
    },

    getView: function() {
        return this.view;
    },

    onPopupClosed: function() {
        // Cleanup
    },

    buildModelAndRenderView: function() {
        return RSVP.Promise.resolve().then((function() {
            var params = {
                folders: this._folders,
                currentFolderId: this._currentFolderId,
                onConfirm: this._onConfirm,
                onCancel: this._onCancel,
                ti18n: this._ti18n
            };
            this.view = new MoveToFolderPopupView(params);
            this.listenTo(this.view, "closed", this.onPopupClosed);
            this.view.render();
        }).bind(this));
    }
});

export default MoveToFolderPopupController;
